import { Typography } from '@euler/app/components/typography';
import { memo } from 'react';
import { View } from 'react-native';
import { useBoardUnit } from '../../functions/useBoardUnit';
import { workshopBoardColors as colors } from '../../workshopBoardColors';
import { BoardColumns } from './boardColumns';

export const TableHeader = memo(({ columns }: { columns: BoardColumns }) => {
  const u = useBoardUnit();
  return (
    <View
      style={{
        flexDirection: 'row',
        paddingBottom: u(14),
        borderBottomWidth: 1,
        borderBottomColor: colors.line,
      }}
    >
      {Object.entries(columns).map(([key, column]) => (
        <Typography.Text
          key={key}
          size={u(22)}
          color={colors.muted}
          style={{ flex: column.flex }}
        >
          {column.title}
        </Typography.Text>
      ))}
    </View>
  );
});
